module.exports = __webpack_public_path__ + "img/event.6a90cff6.png";